import axios from 'axios';

// Base API configuration
const API_URL = process.env.REACT_APP_API_URL || 'https://services.knovik.com';

// Axios instance with base configuration
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if exists
const addTokenToRequest = (config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

// Error handling
const handleError = (error) => {
  if (error.response) {
    // Server responded with an error
    throw error.response.data;
  } else if (error.request) {
    // Request made but no response
    throw new Error('No response from server');
  } else {
    // Error setting up request
    throw error;
  }
};

// Interceptors
api.interceptors.request.use(addTokenToRequest, (error) => Promise.reject(error));
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Global error handling
    if (error.response?.status === 401) {
      // Token invalid or expired
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Authentication Services
export const signup = async (name, email, password) => {
  try {
    const response = await api.post('/auth/signup', { name, email, password });
    const { token, user } = response.data;
    
    // Store token in localStorage
    localStorage.setItem('token', token);
    
    return user;
  } catch (error) {
    handleError(error);
  }
};

export const login = async (email, password) => {
  try {
    const response = await api.post('/auth/login', { email, password });
    const { token, user } = response.data;
    
    // Store token in localStorage
    localStorage.setItem('token', token);
    
    return user;
  } catch (error) {
    handleError(error);
  }
};

export const getCurrentUser = async () => {
  try {
    const response = await api.get('/auth/me');
    return response.data;
  } catch (error) {
    handleError(error);
  }
};